import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  API,
  LocationsAssigned,
} from 'vibeguide';

class MessageLocations extends PureComponent {
  constructor(props) {
    super(props);

    const {
      locations,
      locationsData,
    } = props;

    this.state = {
      locations,
      locationsData,
    };
  }

  onClose = async () => {
    const {
      locations,
    } = this.state;

    const {
      onUpdate,
      mediaFormat,
      onUpdateVisualFileList,
      newVisualFiles,
    } = this.props;

    if (mediaFormat === 'visual') {
      const locationResolutions = locations.length > 0 ? await API.Location.resolutions({
        locations,
      }) : [];

      // Remove visual uploads that no longer apply
      const filteredVisualFiles = newVisualFiles.filter((file) => {
        const hasMatch = locationResolutions.some((resolution) => {
          if (file.targetDisplay?.size[0] === resolution.size[0]
            && file.targetDisplay?.size[1] === resolution.size[1]
            && file.targetDisplay?.rotation === resolution.rotation) {
            return true;
          }

          return false;
        });

        return hasMatch;
      });

      onUpdate({
        resolutions: locationResolutions,
      });
      onUpdateVisualFileList({
        newVisualFiles: filteredVisualFiles,
      });
    }
  };

  /**
   * When the locations are assigned from an object
   */
  onUpdateLocations = async ({
    locations,
    locationsData,
  }) => {
    const {
      onUpdate,
      // companyId,
    } = this.props;

    this.setState({
      locations,
      locationsData,
    });

    onUpdate({
      locations,
      locationsData,
    });
  };

  render() {
    const {
      companyId,
      allowChanges,
      filtersUnassigned,
      resolutionLimit = [],
      mediaFormat,
    } = this.props;

    const {
      locations,
      locationsData,
    } = this.state;

    return (
      <LocationsAssigned
        companyId={companyId}
        locations={locations}
        locationsData={locationsData}
        filtersUnassigned={filtersUnassigned}
        resolutionLimit={resolutionLimit}
        disabled={!allowChanges}
        onUpdate={this.onUpdateLocations}
        allowACAF
        allowCompanies
        onClose={this.onClose}
      />
    );
  }
}

MessageLocations.propTypes = {
  companyId: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object),
  locationsData: PropTypes.shape({
    companies: PropTypes.arrayOf(PropTypes.object),
    locations: PropTypes.arrayOf(PropTypes.object),
  }),
  allowChanges: PropTypes.bool,
  onUpdate: PropTypes.func,
};

MessageLocations.defaultProps = {
  companyId: '',
  locations: [],
  locationsData: {
    companies: [],
    locations: [],
  },
  allowChanges: false,
  onUpdate: () => {},
};

export default MessageLocations;
